import * as tslib_1 from "tslib";
import { Platform } from '@ionic/angular';
import * as signalR from "@microsoft/signalr";
import { nextTick } from "process";
import { BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { LangsRepository } from "./langs.repository";
import { LeadClientRepositoryBUT } from "./lead.clients.repository.but";
import { NotificationService } from "./notification.service";
import { WhatsAppChatType } from "../Enums/whatsappChatType.enum";
import { ChatMessageType } from "../model/leadClients/lead.client.whatsapp.chatmessagetype";
import { LeadClientWhatsappMessage } from "../model/leadClients/lead.client.whatsapp.message";
import { PoviderType } from "../model/leadClients/lead.client.whatsapp.providertype";
var WhatsappService = /** @class */ (function () {
    function WhatsappService(langsRepository, leadClientRepository, notificationService, platform) {
        this.langsRepository = langsRepository;
        this.leadClientRepository = leadClientRepository;
        this.notificationService = notificationService;
        this.platform = platform;
        this.isConnected = false;
        this.signalRConnectionSubject = new BehaviorSubject(null);
        this.signalRConnection$ = this.signalRConnectionSubject.asObservable();
        this.receivedMessageSubject = new BehaviorSubject(null);
        this.receivedMessage$ = this.receivedMessageSubject.asObservable();
        this.signalRConnectionCloseRequested = false;
        this.token = "";
        this.chatType = WhatsAppChatType.Client;
        this.messageFileErrorPlaceholder = "__messagefile_error__";
        // region Sending messages
        this.mediaTypes = ['video', 'audio', 'image'];
    }
    Object.defineProperty(WhatsappService.prototype, "currentLang", {
        get: function () { return this.langsRepository.current; },
        enumerable: true,
        configurable: true
    });
    ;
    WhatsappService.prototype.setSignalRConnection = function (signalRConnection) {
        this.signalRConnectionSubject.next(signalRConnection);
    };
    WhatsappService.prototype.setReceivedMessage = function (receivedMessage) {
        this.receivedMessageSubject.next(receivedMessage);
    };
    WhatsappService.prototype.setToken = function (token) {
        this.token = token;
    };
    WhatsappService.prototype.setWhatsAppChatType = function (chatType) {
        this.chatType = chatType;
    };
    WhatsappService.prototype.startConnection = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                try {
                    console.log('startConnection', userId);
                    this.signalRConnectionCloseRequested = false;
                    this.signalRConnection.start().then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var _1;
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!this.signalRConnection) return [3 /*break*/, 7];
                                    return [4 /*yield*/, this.signalRConnection.invoke('ConnectUser', userId)];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2:
                                    _a.trys.push([2, 5, , 6]);
                                    if (!sessionStorage.getItem('crm-app-impersonation-session')) return [3 /*break*/, 4];
                                    return [4 /*yield*/, this.signalRConnection.invoke('MarkImpersonationSession')];
                                case 3:
                                    _a.sent();
                                    sessionStorage.removeItem('crm-app-impersonation-session');
                                    _a.label = 4;
                                case 4: return [3 /*break*/, 6];
                                case 5:
                                    _1 = _a.sent();
                                    return [3 /*break*/, 6];
                                case 6:
                                    this.isConnected = true;
                                    _a.label = 7;
                                case 7: return [2 /*return*/];
                            }
                        });
                    }); }, function (err) {
                        console.error('start signalRConnection rejected', err);
                    }).catch(function (err) {
                        console.error('start signalRConnection error', err);
                    });
                }
                catch (err) {
                    console.error('startConnection error', err);
                    setTimeout(function () {
                        _this.startConnection(userId);
                    }, 5000);
                }
                return [2 /*return*/];
            });
        });
    };
    ;
    WhatsappService.prototype.subscribe = function (user) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var connectionOptions, connection;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.platform.ready()];
                    case 1:
                        _a.sent();
                        this.signalRConnectionSubscription = this.signalRConnection$.subscribe(function (con) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(con !== null && !this.signalRConnection)) return [3 /*break*/, 2];
                                        this.signalRConnection = con;
                                        return [4 /*yield*/, this.startConnection(user.id)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); });
                        connectionOptions = {
                            transport: signalR.HttpTransportType.WebSockets,
                            skipNegotiation: true
                        };
                        connection = new signalR.HubConnectionBuilder()
                            .withUrl(environment.baseFixUrl + "chatHub", connectionOptions)
                            .configureLogging(signalR.LogLevel.Information)
                            .withAutomaticReconnect()
                            .build();
                        // Handle ForceLogout notification from backend
                        connection.on("ForceLogout", function (data) {
                            console.log("Received ForceLogout notification", data);
                            window.dispatchEvent(new CustomEvent('force-logout', { detail: data }));
                        });
                        connection.on("CompanySwitched", function (companyId, jwt, isImpersonation) {
                            if (jwt) {
                                var isInIframe = (parent !== window);
                                var hostname = isInIframe ? document.referrer : window.location.hostname;
                                var authKey = "fxa-" + hostname;
                                try {
                                    var raw = localStorage.getItem(authKey);
                                    if (raw) {
                                        var data = JSON.parse(raw);
                                        data.jwt = jwt;
                                        localStorage.setItem(authKey, JSON.stringify(data));
                                    }
                                }
                                catch (_) { }
                            }
                            if (isImpersonation) {
                                try {
                                    sessionStorage.setItem('crm-app-impersonation-session', '1');
                                }
                                catch (_) { }
                            }
                            window.location.reload();
                        });
                        connection.onclose(function (error) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!!this.signalRConnectionCloseRequested) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.startConnection(user.id)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        if (error) {
                                            console.error("error in connection.onclose", error);
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        this.setSignalRConnection(connection);
                        return [2 /*return*/];
                }
            });
        });
    };
    WhatsappService.prototype.unsubscribe = function (user) {
        var _this = this;
        if (this.signalRConnection) {
            if (this.signalRConnection.state == signalR.HubConnectionState.Connected) {
                this.signalRConnection.invoke('DisconnectUser', user.id)
                    .finally(function () {
                    if (_this.signalRConnection) {
                        _this.signalRConnectionCloseRequested = true;
                        if (_this.isConnected) {
                            _this.signalRConnection.stop().then(function (_) {
                                _this.signalRConnection = null;
                                _this.setSignalRConnection(null);
                                _this.isConnected = false;
                            });
                        }
                    }
                });
            }
            else {
                this.signalRConnection = null;
                this.setSignalRConnection(null);
            }
            if (this.signalRConnectionSubscription) {
                this.signalRConnectionSubscription.unsubscribe();
            }
            this.setReceivedMessage(null);
            this.receivedMessage = null;
            if (this.receivedMessageSubscription) {
                this.receivedMessageSubscription.unsubscribe();
            }
        }
    };
    WhatsappService.prototype.formatWhatsappMessage = function (msg) {
        var _this = this;
        if (!msg.message) {
            return "";
        }
        msg.message = msg.message.replace(/\n/g, "<br />");
        var urlRegex = /\b((https?:\/\/\S+(?:png|jpe?g|gif)\S*)|(https?:\/\/api\-eu\.nexmo\.com\/v3\/media\/\S+))\b/gi;
        var fileRegex = /\b(leadClient\/getMessageFile\/(\w+)\/)(.+?\.([a-zA-Z]\w+\b|$))/i;
        var fileNameRegex = /[^\/]+$/;
        var datePast = new Date();
        var createDate = new Date(msg.createDate);
        if (urlRegex.test(msg.message)) {
            datePast.setDate(datePast.getDate() - 90);
            if (createDate <= datePast) {
                return msg.message.replace(urlRegex, "<b>" + this.currentLang.words["image-deleted"] + "</b>");
            }
            return msg.message
                // replace uploaded images to alias with https (instead of http)
                .replace("http://prod2-clp-fixdigital.s3-website-eu-west-1.amazonaws.com", "https://lpc.fixdigital.co.il")
                .replace(urlRegex, "<a href='$1' target='_blank'><img src='$1' alt='image' /></a>");
        }
        if (fileRegex.test(msg.message)) {
            datePast.setDate(datePast.getDate() - 90);
            if (createDate <= datePast || msg.message.includes('/deleted/')) {
                return msg.message.replace(fileRegex, "<b>" + this.currentLang.words["image-deleted"] + "</b>");
            }
            if (!msg.fileUrl) {
                var filename = msg.filename ? encodeURIComponent(msg.filename) : encodeURIComponent(msg.message.match(fileRegex)[3]);
                var url_1 = msg.message.match(fileRegex)[1] + filename;
                var getMessageFileMethodPromise = this.chatType === WhatsAppChatType.Client
                    ? this.leadClientRepository.getMessageFile(url_1)
                    : this.leadClientRepository.getMessageFileWithCrmToken(this.token, url_1);
                getMessageFileMethodPromise.then(function (blob) {
                    msg.file = blob;
                    var fileUrl = window.URL.createObjectURL(blob);
                    msg.fileUrl = fileUrl;
                })
                    .catch(function (reason) {
                    console.log('Error in getMessageFileMethodPromise: ', reason, url_1, msg.messageContentType, msg.message);
                    // Stop the retry loop and show the original message text instead.
                    msg.fileUrl = _this.messageFileErrorPlaceholder;
                    msg.imgSrc = null;
                });
                msg.fileUrl = '/loading.svg';
            }
            // If loading failed, render the original message (including the getMessageFile/... text)
            // and do not try to request again.
            if (msg.fileUrl === this.messageFileErrorPlaceholder) {
                msg.imgSrc = null;
                // Wrap with a light red background to make the error visible to the user.
                return "<div style=\"background-color:#ffe6e6; padding:6px 8px; border-radius:6px; display:inline-block;\">" + msg.message + "</div>";
            }
            if (msg.messageContentType == "video") {
                return msg.message.replace(fileRegex, "<video controls><source src='" + msg.fileUrl + "'> </video>");
            }
            if (msg.messageContentType == "audio") {
                return msg.message.replace(fileRegex, "<audio controls><source src='" + msg.fileUrl + "'> </audio>");
            }
            if (msg.messageContentType == "file") {
                fileRegex.lastIndex = 0;
                var match = fileRegex.exec(msg.message);
                var filename = "";
                if (msg.filename) {
                    filename = msg.filename;
                }
                else {
                    var matchFilename = fileNameRegex.exec(match[0]);
                    filename = match ? matchFilename[0] : "unknown";
                }
                return msg.message.replace(fileRegex, this.createFileMessageHtml(filename, msg.fileUrl));
            }
            nextTick(function () {
                msg.imgSrc = msg.fileUrl;
            });
            return msg.message.replace(fileRegex, "");
        }
        if (msg.adPreview) {
            return msg.message + " " + msg.adPreview;
        }
        var anchorRegex = /(<a[^>]*>)([^<]+)(<\/a>)/gi;
        if (msg.messageType === ChatMessageType.Template && msg.filename && anchorRegex.test(msg.message)) {
            return msg.message.replace(anchorRegex, "$1" + msg.filename + "$3");
        }
        return msg.message;
    };
    WhatsappService.prototype.createFileMessageHtml = function (filename, fileUrl) {
        return "<div class='file'>" +
            "<span class='file-icon'></span>" +
            "<div class='meta'>" +
            ("<div class='title'>" + filename + "</div>") +
            ("<a target=\"_blank\" href='" + fileUrl + "' class=\"download\" download=" + filename + ">Download</a>") +
            "</div>" +
            "</div>";
    };
    WhatsappService.prototype.mapFileType = function (file) {
        var fileType = file.type;
        for (var _i = 0, _a = this.mediaTypes; _i < _a.length; _i++) {
            var category = _a[_i];
            if (fileType.startsWith(category + "/")) {
                return category;
            }
        }
        return "file";
    };
    WhatsappService.prototype.sendReplyMessage = function (params) {
        var _this = this;
        var request$ = params.token
            ? this.leadClientRepository.sendReplyWhatsappMessageWithCrmToken(params.token, params.leadClientId, params.messageText, params.userId, params.filesToUpload, params.selectedPhone)
            : this.leadClientRepository.sendReplyWhatsappMessage(params.leadClientId, params.messageText, params.userId, params.filesToUpload, params.selectedPhone);
        return request$.pipe(map(function (response) {
            var result = response.data;
            if (!result || !result.success) {
                throw new Error((result && result.message) || "Send message failed");
            }
            var senderOrigin = params.senderOrigin || "";
            var senderDestination = params.senderDestination || "";
            var hasFiles = !!(params.filesToUpload && params.filesToUpload.length > 0);
            if (hasFiles) {
                var uploadData = result.data || {};
                var fileUrls = Array.isArray(uploadData.filesUrl) ? uploadData.filesUrl : [];
                var contentMessageType_1 = params.filesToUpload.length === 1 ? _this.mapFileType(params.filesToUpload[0]) : "file";
                return fileUrls.map(function (fileUrl) {
                    return new LeadClientWhatsappMessage(0, PoviderType.Whatsapp, new Date(), params.leadClientId, ChatMessageType.Reply, fileUrl, senderOrigin, senderDestination, params.userId, contentMessageType_1);
                });
            }
            return [
                new LeadClientWhatsappMessage(0, PoviderType.Whatsapp, new Date(), params.leadClientId, ChatMessageType.Reply, params.messageText, senderOrigin, senderDestination, params.userId, "text")
            ];
        }));
    };
    // endregion
    // region UI helpers - textarea Enter/newline handling
    /**
     * Compute handling for Enter in a textarea.
     * - Plain Enter => send
     * - Any modifier (Ctrl/Shift/Alt/Meta) + Enter => insert newline at caret
     */
    WhatsappService.prototype.handleTextareaEnterKey = function (event, currentText) {
        if (event.key !== "Enter") {
            return { updatedText: null, newCaret: null, shouldSend: false, preventDefault: false };
        }
        var textarea = event.target;
        if (event.ctrlKey || event.shiftKey || event.altKey || event.metaKey) {
            // Insert newline at caret (replace selection if any)
            var selectionStart = textarea.selectionStart || 0;
            var selectionEnd = textarea.selectionEnd || 0;
            var before = currentText.slice(0, selectionStart);
            var after = currentText.slice(selectionEnd);
            var updatedText = before + "\n" + after;
            return {
                updatedText: updatedText,
                newCaret: selectionStart + 1,
                shouldSend: false,
                preventDefault: true
            };
        }
        // Plain Enter => send
        return { updatedText: null, newCaret: null, shouldSend: true, preventDefault: true };
    };
    // endregion
    WhatsappService.prototype.getReferralUrl = function (referralData) {
        if (!referralData) {
            return null;
        }
        try {
            var referral = JSON.parse(referralData);
            // WhatsApp Referral может содержать source_url или sourceUrl
            return referral.source_url || referral.sourceUrl || null;
        }
        catch (e) {
            console.warn('Failed to parse referralData:', e);
            return null;
        }
    };
    return WhatsappService;
}());
export { WhatsappService };
